import { Alert, Box } from '@mui/material'
import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useGetNotification, useGetOrder, useGetPayloadMetaData } from '../../../../logic/useApiQuery'
import { useNotificationContentOverride } from '../../../context/notification-content-override/NotificationContentOverrideContext'
import { LoadingScreen } from '../../LoadingScreen'
import { CashToCloseEnterMoreOrComplete } from './CashToCloseEnterMoreOrComplete'
import { CashToCloseTransactionsSummary } from './CashToCloseTransactionsSummary'
import { checkIfPastDue } from '../../../../utils'
import { PayloadProcessingStateProvider } from '../../../context/payload-processing-state/PayloadProcessingState'
import dayjs from 'dayjs'
import { PortalOrder } from '../../../../types'
import { isAdhocPortalOrder } from '../../../../utils/isAdhocPortalOrder'

export function CashToCloseTask() {
  const { closingId, id } = useParams()
  const { search } = useLocation()
  const { data: notification } = useGetNotification()
  const { data: orderData } = useGetOrder(closingId ?? '', search ?? '')
  const { isLoading: getPayloadMetaDataLoading } = useGetPayloadMetaData(closingId ?? '', id ?? '', search ?? '', { useErrorBoundary: true})

  const rawDueDate = (orderData?.Order as PortalOrder)?.CashToCloseDetails?.dueDate
  const dueDate = rawDueDate ? dayjs(rawDueDate).format('dddd, MMMM D, YYYY [at] hh:mm A z') : null
  const pastDue = dueDate ? (orderData && orderData.Order && !isAdhocPortalOrder(orderData.Order) && orderData.Order.CashToCloseDetails && !notification?.IsComplete && !!(orderData?.Order as PortalOrder)?.CashToCloseDetails?.dueDate && checkIfPastDue(orderData?.Order.CashToCloseDetails.dueDate)) : false
  const dueDateText = dueDate
    ? 'This payment must be submitted by: <strong>' + dueDate + '</strong>.'
    : '<br/> <br/> <strong> To ensure a smooth closing, please contact your title/escrow company to confirm the payment cutoff time. </strong>'
  const cashToCloseContextText = notification?.Content + '<br/><br/> Please enter the amount of your payment, agree to the payment terms, and select complete payment. Then, securely link your bank account using Plaid to submit your payment. Please note that a $50 fee is applied to each payment transaction. <a href="https://plaid.com/what-is-plaid/">Click here to learn more about Plaid account linking.</a> <br/><br/> Once all of your payments have been successfully submitted, click <strong> Complete </strong> below. ' + dueDateText

  const { setNotificationContentOverride } = useNotificationContentOverride()

  const shouldInitiatePayment = !(notification && notification.IsComplete)

  useEffect(() => {
    setNotificationContentOverride(cashToCloseContextText)
  }, [setNotificationContentOverride, cashToCloseContextText])

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://payload.com/Payload.js'

    document.head.appendChild(script)

    // Clean up when component unmounts
    return () => {
      document.head.removeChild(script)
    }
  }, [])

  if (!notification || getPayloadMetaDataLoading) return <LoadingScreen/>

  return (
    <PayloadProcessingStateProvider>
      <Box sx={{width: '100%', maxWidth: '700px'}}>
        { pastDue &&
          <Alert severity="error" sx={{ mb: 3 }}>
            This task is past due. Online payments can no longer be accepted.
          </Alert>
        }
        <CashToCloseTransactionsSummary expandedByDefault={!notification.IsComplete && !pastDue}/>
        { shouldInitiatePayment && !pastDue &&
          <Box mb={2}>
            <CashToCloseEnterMoreOrComplete/> 
          </Box>
        }
      </Box>
    </PayloadProcessingStateProvider>
  )
}

